/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostFamilyAccountRequestBodyTypename = "PostFamilyAccountRequestBody" as const;

/**
 *
 * @export
 * @interface PostFamilyAccountRequestBody
 */
export interface PostFamilyAccountRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  dateOfBirth: string;
  /**
   *
   * @type {object}
   * @memberof PostFamilyAccountRequestBody
   */
  externalIds?: object;
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  gender: PostFamilyAccountRequestBodyGenderEnum;
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  insuranceCard?: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  kanaFirstName: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  kanaLastName: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  lastName: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PostFamilyAccountRequestBody
   */
  otherMedicalImages?: Array<string>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostFamilyAccountRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PostFamilyAccountRequestBodyGenderEnum {
  Male = "male",
  Female = "female",
  None = "none",
}

export function PostFamilyAccountRequestBodyFromJSON(json: any): PostFamilyAccountRequestBody {
  return PostFamilyAccountRequestBodyFromJSONTyped(json, false);
}

export function PostFamilyAccountRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostFamilyAccountRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostFamilyAccountRequestBodyTypename,

    dateOfBirth: json["date_of_birth"],
    externalIds: !exists(json, "external_ids") ? undefined : json["external_ids"],
    firstName: json["first_name"],
    gender: json["gender"],
    insuranceCard: !exists(json, "insurance_card") ? undefined : json["insurance_card"],
    kanaFirstName: json["kana_first_name"],
    kanaLastName: json["kana_last_name"],
    lastName: json["last_name"],
    otherMedicalImages: !exists(json, "other_medical_images") ? undefined : json["other_medical_images"],
  };
}

export function PostFamilyAccountRequestBodyToJSON(object?: PostFamilyAccountRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: value.dateOfBirth,
    external_ids: value.externalIds,
    first_name: value.firstName,
    gender: value.gender,
    insurance_card: value.insuranceCard,
    kana_first_name: value.kanaFirstName,
    kana_last_name: value.kanaLastName,
    last_name: value.lastName,
    other_medical_images: value.otherMedicalImages,
  };
}
